(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    const scroller = document.querySelector('.collection-showcase__slideshow slideshow-slides');
    const thumb = document.querySelector('.collection-showcase__scrollbar-thumb');
    if (!scroller || !thumb) return;

    const update = () => {
      const { scrollWidth, clientWidth, scrollLeft } = scroller;
      if (scrollWidth <= clientWidth) {
        thumb.style.width = '100%';
        thumb.style.left = '0%';
        return;
      }
      const ratio = clientWidth / scrollWidth;
      const maxScroll = scrollWidth - clientWidth;
      const progress = maxScroll > 0 ? scrollLeft / maxScroll : 0;
      thumb.style.width = (ratio * 100) + '%';
      thumb.style.left = (progress * (100 - ratio * 100)) + '%';
    };

    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

    function panelOf(details) {
      return details.querySelector('.product-faq__panel');
    }

    function animate(details, opening) {
      var panel = panelOf(details);
      if (!panel || REDUCED.matches || typeof panel.animate !== 'function') return;

      if (panel.__faqAnimation) panel.__faqAnimation.cancel();

      var height = panel.scrollHeight;
      var frames = opening
        ? [
            { height: '0px', opacity: 0 },
            { height: height + 'px', opacity: 1 },
          ]
        : [
            { height: height + 'px', opacity: 1 },
            { height: '0px', opacity: 0 },
          ];

      var animation = panel.animate(frames, {
        duration: 260,
        easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
      });

      panel.__faqAnimation = animation;
      animation.onfinish = function () {
        panel.__faqAnimation = null;
      };
    }

    function init(root) {
      if (!root || root.__faqReady) return;
      root.__faqReady = true;

      var singleOpen = root.dataset.singleOpen === 'true';
      var items = Array.prototype.slice.call(root.querySelectorAll('.product-faq__item'));

      items.forEach(function (details) {
        details.addEventListener('toggle', function () {
          if (details.open) {
            animate(details, true);

            if (singleOpen) {
              items.forEach(function (other) {
                if (other !== details && other.open) {
                  animate(other, false);
                  other.open = false;
                }
              });
            }
          }
        });

        // Close with an animation rather than an instant collapse.
        var summary = details.querySelector('.product-faq__question');
        if (!summary) return;

        summary.addEventListener('click', function (event) {
          if (!details.open || REDUCED.matches) return;

          event.preventDefault();
          animate(details, false);

          var panel = panelOf(details);
          var animation = panel && panel.__faqAnimation;

          if (animation) {
            animation.onfinish = function () {
              panel.__faqAnimation = null;
              details.open = false;
            };
          } else {
            details.open = false;
          }
        });
      });
    }

    function initAll() {
      document.querySelectorAll('.product-faq').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Theme editor: re-bind on section render, and open the block being edited.
    document.addEventListener('shopify:section:load', initAll);

    document.addEventListener('shopify:block:select', function (event) {
      var details = event.target.closest ? event.target.closest('.product-faq__item') : null;
      if (details && !details.open) details.open = true;
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
